import React from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Image,
  Row,
  useAccordionButton,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactTimeago from "react-timeago";
import { handleCancelBid } from "../../../../functions/flow-interactions/transactions";
import ReviewMadeBidAuctionStore from "../../../forms/buying/reviewmadebidauctionstore/reviewmadebidauctionstore";
const StoreBuyingNames = (props) => {
  const { bids = [], filterTerm } = props;
  const findLogo = (
    <Image
      className="store-thumb-image"
      src="/assets/img/store/fnamestore.png"
    />
  );
  let filteredBuyOffers = bids
    .filter((bid) => bid.type === "blind")
    .filter((lease) =>
      lease.name.toLowerCase().includes(filterTerm.toLowerCase())
    );
  let filteredBidOffers = bids
    .filter((bid) => bid.type === "auction")
    .filter((lease) =>
      lease.name.toLowerCase().includes(filterTerm.toLowerCase())
    );

  // //console.log(filteredBuyOffers);

  // //console.log(findUser)
  // const filteredNameBids = leases.filter((lease) => lease.salePrice > 0);

  function CustomToggle({ children, eventKey, lease }) {
    const decoratedOnClick = useAccordionButton(eventKey);
    return (
      <>
        <div className="d-none d-lg-block">
          <Button
            variant="find-outline-commerce"
            size="sm"
            onClick={decoratedOnClick}
          >
            {children}
          </Button>
        </div>
        <div className="d-lg-none">
          <Button
            onClick={decoratedOnClick}
            style={{
              backgroundImage: "var(--accordion-chevron)",
              width: "26px",
              height: "26px",
              backgroundColor: "var(--background)",
              borderColor: "var(--background)",
              boxShadow: "none",
            }}
          ></Button>
        </div>
      </>
    );
  }

  return (
    <Container fluid={+true} id="store-names-buying" className="px-0 mb-3">
      <Card>
        <Card.Body>
          <Row>
            <Col align="left">
              <h4>Your active bids/offers on names</h4>
            </Col>
          </Row>
          <Row className="mt-4">
            <p>
              <b>Offers:</b>
            </p>
          </Row>
          <table className="store-table" id="store-offering-names-table">
            <tbody>
              {filteredBuyOffers.length > 0 ? (
                filteredBuyOffers.map((bid, i) => {
                  return (
                    <React.Fragment key={i + "store-offering-names-row"}>
                      <tr
                        id={i + "store-offering-names-row"}
                        className="store-row"
                      >
                        <td className="store-thumb-col">{findLogo}</td>
                        <td className="store-name-col">
                          <Link to={"/mp/FIND/" + bid.name}>
                            <span className="fw-bold">
                              <span className="themeColor">{bid.name}</span>
                              .find{" "}
                            </span>
                          </Link>
                        </td>
                        <td className="store-sticker-col"></td>
                        <td className="store-price-col">
                          <div className="d-none d-lg-block">
                            {" "}
                            Offer:{" "}
                            <b>{parseFloat(bid.amount).toFixed(2)} FUSD</b>
                          </div>
                          <div className="d-block d-lg-none">
                            <b>{parseFloat(bid.amount).toFixed(2)} FUSD</b>{" "}
                          </div>
                        </td>
                        <td className="store-time-left-col">
                          <span className="store-sticker">
                            Waiting for response{" "}
                          </span>
                        </td>

                        <td className="store-buttons-col">
                          <Button
                            onClick={() => handleCancelBid(bid.name)}
                            variant="find-outline-commerce-red"
                          >
                            Remove
                          </Button>
                        </td>
                      </tr>
                      <tr className="mobile-row">
                        <td className="mobile-store-sticker-col">
                          {" "}
                          <span className="store-sticker">Waiting </span>
                        </td>
                        <td className="mobile-store-time-left-col"></td>
                        <td align="end">
                          <Button
                            onClick={() => handleCancelBid(bid.name)}
                            variant="find-outline-commerce-red"
                          >
                            Remove
                          </Button>
                        </td>
                      </tr>
                    </React.Fragment>

                    // <Row key={i} className="my-4 align-items-center">
                    //   <Col className="col-1" xs="2" md="1">
                    //     {findLogo}
                    //   </Col>
                    //   <Col xs="10" md="auto">
                    //     <b>{bid.name}</b>
                    //   </Col>
                    //   <Col xs="12" md="auto">
                    //     Your offer: <b>{parseFloat(bid.amount).toFixed(2)} FUSD</b>
                    //   </Col>
                    //   <Col xs="12" md="auto">
                    //     Waiting for response
                    //   </Col>
                    //   <Col></Col>
                    //   <Col align="right">
                    // <Button
                    //   onClick={() => handleCancelBid(bid.name)}
                    //   variant="find-outline-commerce-red"
                    // >
                    //   Remove
                    // </Button>
                    //   </Col>
                    // </Row>
                  );
                })
              ) : (
                <tr>
                  <td>
                    <small>
                      You are not currently making offers on any names
                    </small>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="seperator100 my-4"></div>

          <Row>
            <p>
              <b>For auction:</b>
            </p>
          </Row>
          <Accordion>
            <table className="store-table" id="store-bidding-names-table">
              <tbody>
                {filteredBidOffers.length > 0 ? (
                  filteredBidOffers.map((bid, i) => {
                    // //console.log(bid);
                    let ended;
                    if (bid.lease.auctionEnds < bid.lease.currentTime) {
                      ended = true;
                    } else {
                      ended = false;
                    }
                    return (
                      <React.Fragment key={i + "store-bidded-names-row"}>
                        <tr
                          id={i + "store-bidded-names-row"}
                          className="store-row"
                        >
                          <td className="store-thumb-col">{findLogo}</td>
                          <td className="store-name-col">
                            <Link to={"/mp/FIND/" + bid.name}>
                              <span className="fw-bold">
                                <span className="themeColor">{bid.name}</span>
                                .find{" "}
                              </span>
                            </Link>
                          </td>
                          <td className="store-sticker-col"></td>
                          <td className="store-price-col">
                            <div className="d-none d-lg-block">
                              Your bid:{" "}
                              <b>{parseFloat(bid.amount).toFixed(2)} FUSD</b>{" "}
                            </div>
                            <div className="d-block d-lg-none">
                              <b>{parseFloat(bid.amount).toFixed(2)} FUSD</b>{" "}
                            </div>
                          </td>
                          <td className="store-time-left-col">
                            <span className="store-sticker">
                              {!ended ? "Ends: " : "Ended: "}
                              <ReactTimeago
                                date={new Date(bid.lease.auctionEnds * 1000)}
                                timestyle="twitter"
                              />
                            </span>
                          </td>

                          <td className="store-buttons-col">
                            <CustomToggle eventKey={i}>
                              {" "}
                              View Auction
                            </CustomToggle>
                          </td>
                        </tr>
                        <tr>
                          <td className="d-none d-md-table-cell" colSpan={6}>
                            <Accordion.Collapse eventKey={i}>
                              <Card.Body>
                                <div
                                  className="collapse show"
                                  id="collapseExample"
                                >
                                  <ReviewMadeBidAuctionStore
                                    filteredLease={bid.lease}
                                  />
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </td>
                        </tr>

                        <tr className="mobile-row">
                          <td className="mobile-store-sticker-col">
                            {bid.latestBid && (
                              <span className="store-sticker">Bids </span>
                            )}
                          </td>
                          <td className="mobile-store-time-left-col"></td>
                          <td align="end">
                            <CustomToggle eventKey={i}>
                              {" "}
                              View Auction
                            </CustomToggle>
                          </td>
                        </tr>
                        <tr>
                          <td className="d-table-cell d-md-none" colSpan={3}>
                            <Accordion.Collapse eventKey={i}>
                              <Card.Body>
                                <div
                                  className="collapse show"
                                  id="collapseExample"
                                >
                                  <ReviewMadeBidAuctionStore
                                    filteredLease={bid.lease}
                                  />
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </td>
                        </tr>
                      </React.Fragment>

                      // <React.Fragment key={i}>
                      //   <Row key={i} className="my-4 align-items-center">
                      //     <Col className="col-1" xs="2" md="1">
                      //       {findLogo}
                      //     </Col>
                      //     <Col xs="10" md="auto">
                      //       <b>{bid.name}</b>
                      //     </Col>
                      //     <Col>
                      //       Start:{" "}
                      //       <b>
                      //         {parseFloat(bid.lease.auctionStartPrice).toFixed(2)}{" "}
                      //         FUSD
                      //       </b>
                      //     </Col>
                      //     <Col xs="12" md="auto">
                      //       Your bid:{" "}
                      //       <b>{parseFloat(bid.amount).toFixed(2)} FUSD</b>
                      //     </Col>
                      //     <Col xs="12" md="auto">
                      //       {bid.lease.auctionEnds > bid.lease.currentTime
                      //         ? "Ends:"
                      //         : "Ended:"}{" "}
                      //       &nbsp;
                      //       <b>
                      //         <ReactTimeago
                      //           date={new Date(bid.lease.auctionEnds * 1000)}
                      //           timestyle="twitter"
                      //         />{" "}
                      //       </b>{" "}
                      //     </Col>
                      //     <Col align="right">
                      //       {/* customtoggle here for view auction details and increasebid */}
                      //       <CustomToggle eventKey={i}>View Auction</CustomToggle>
                      //     </Col>
                      //   </Row>
                      //   <Accordion.Collapse eventKey={i}>
                      //     <Card.Body>
                      //       <div className="collapse show" id="collapseExample">
                      //         <ReviewMadeBidAuctionStore
                      //           filteredLease={bid.lease}
                      //         />
                      //       </div>
                      //     </Card.Body>
                      //   </Accordion.Collapse>
                      // </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td>
                      <small>You are not currently bidding on any names</small>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Accordion>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default StoreBuyingNames;
